/**
 * LgSlider.js — 4-up card slider with arrows-only navigation (no dots)
 */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class LgSlider {
  constructor(selector = '.lg-slider') {
    this.el = document.querySelector(selector);
    if (!this.el) return;

    this.swiper = new Swiper(this.el, {
      modules: [Navigation],
      slidesPerView: 4,
      spaceBetween: 16,
      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next'),
        prevEl: this.el.querySelector('.swiper-button-prev'),
      },
    });
  }
}
